var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alertWrapper',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChanged),expression:"visibilityChanged"}],staticClass:"module module-alert padding_large",class:[
    { 'show-up': _vm.isVisible },
    _vm.baseAnimation,
    _vm.moduleClass,
    'theme-' + _vm.data.theme,
    'text-' + _vm.currentTheme().text_color
  ],attrs:{"iconsColor":_vm.theme.icons,"textColor":_vm.theme.text,"backgroundColor":_vm.theme.background}},[_c('ModuleContainer',[_c('div',{staticClass:"alert-icon"},[_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.svgIcons.alert)}})]),_c('div',{staticClass:"alert-main"},[_c('ModuleHeading',{attrs:{"level":3}},[_vm._v(_vm._s(_vm.data.alert_title))]),(_vm.data.links)?_c('LinksLine',{attrs:{"data":_vm.data.links}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }